const SellerMarketProductService = {

  /**
     * Generate attribute initial value
     * @param {array} attributes - Product Attribute
     * @param {object} initialValue - Custom initial value
     */
  buildFormikAttributeInitialValue: (attributes, initialValue = {}) => {
    let attributeInitialValue = {}

    attributes.forEach((attribute) => {
      if (attribute.allow_multiple_values) {
        attributeInitialValue[attribute.code] = []
      }
      else {
        attributeInitialValue[attribute.code] = ''
      }
    })

    return {
      ...attributeInitialValue,
      ...initialValue
    }
  }
}

export default SellerMarketProductService
